/** @jsxImportSource solid-js */
import { cva, type VariantProps } from 'class-variance-authority'
import { type JSX, splitProps } from 'solid-js'
import { cn } from '../cn'

export const buttonVariants = cva(
  'font-bold transition-colors disabled:pointer-events-none',
  {
    variants: {
      variant: {
        // active: press feedback is DS Button Primary/Press; the React
        // variant predates it and gets backported separately.
        primary:
          'bg-[#176361] text-white active:bg-[#0D413F] disabled:bg-[#639897]',
        ghost: 'text-[#176361] disabled:opacity-50',
      },
      size: {
        lg: 'h-[52px] w-full rounded-full',
        sm: 'h-9 text-base',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'lg',
    },
  },
)

export interface ButtonProps
  extends
    JSX.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export function Button(props: ButtonProps) {
  const [local, rest] = splitProps(props, ['variant', 'size', 'class'])
  return (
    <button
      class={cn(
        buttonVariants({ variant: local.variant, size: local.size }),
        local.class,
      )}
      {...rest}
    />
  )
}
